module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  PORT: process.env.PORT,
  REACT_APP_CLIENTID: process.env.REACT_APP_CLIENTID,
  REACT_APP_FILE_UPLOAD: process.env.REACT_APP_FILE_UPLOAD,
  REACT_APP_FORM_URL: process.env.REACT_APP_FORM_URL,
};
